import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Disclaimer } from "@/components/Shared";
import api from "@/lib/api";

export default function Learn() {
  const [strategies, setStrategies] = useState([]);
  useEffect(() => {
    api.get("/strategies").then((r) => setStrategies(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="learn-page">
      <PageHero
        eyebrow="Strategy Library"
        title="Strategy & Framework Library"
        subtitle="Educational trading systems — each framework has its own page covering concept, market conditions, components, rules, examples, risk considerations and limitations."
        crumbs={[{ label: "Strategy Library" }]}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <section>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border rounded-lg overflow-hidden">
            {strategies.map((s) => (
              <Link key={s.slug} to={`/strategy/${s.slug}`} data-testid={`learn-strategy-${s.slug}`} className="group bg-white p-6 hover:bg-navy transition-colors duration-300">
                <div className="flex items-center justify-between">
                  <span className="eyebrow text-gold">{s.condition}</span>
                  <ArrowUpRight className="h-4 w-4 text-slate-300 group-hover:text-gold transition-colors" />
                </div>
                <h3 className="font-display text-lg font-semibold text-navy group-hover:text-white mt-3 transition-colors">{s.name}</h3>
                <p className="mt-2 text-sm text-slate-500 group-hover:text-slate-300 line-clamp-2 transition-colors">{s.concept}</p>
              </Link>
            ))}
          </div>
          <div className="mt-10"><Disclaimer /></div>
        </section>
      </div>
    </div>
  );
}
